import { combineEpics, type Epic } from 'redux-observable';
import type { Action } from '../state/actions/types';
import type { State } from '../state/types';
import { componentDeleted, dialogDisplayed, failure, cancel } from './callbacks';
import { deleteComponentRequest, deleteComponentSafe, deleteComponentConfirmed } from './delete';

const rootEpic: Epic<Action, State> = combineEpics(
	deleteComponentRequest,
	deleteComponentSafe,
	deleteComponentConfirmed,
	dialogDisplayed,
	componentDeleted,
	failure,
	cancel,
);

export default rootEpic;
